import React from 'react';

import { Button } from '@mui/material';

import { BOOK_LIVE_DEMO_URL } from 'app/constants';

import useStyles from './styles';

interface Props {
    color?: 'black' | 'white';
    size?: 'small' | 'regular';
    fullWidth?: boolean;
    shadows?: boolean;
    className?: string;
}

const BookDemoButton: React.FC<Props> = ({
    size = 'regular',
    fullWidth = false,
    color = 'white',
    shadows = true,
    className
}) => {
    const { classes, cx } = useStyles();

    return (
        <Button
            disableElevation
            disableRipple
            variant="contained"
            color="inherit"
            fullWidth={fullWidth}
            className={cx(
                classes.root,
                {
                    [classes._small]: size === 'small',
                    [classes._regular]: size === 'regular',
                    [classes._black]: color === 'black',
                    [classes._white]: color === 'white',
                    [classes._shadows]: shadows
                },
                className
            )}
            href={BOOK_LIVE_DEMO_URL}
            target="_blank"
        >
            {'Book a demo'}
        </Button>
    );
};

export default BookDemoButton;
